<template>
    <el-select ref="selectDom" :placeholder="placeholder" @blur.native.capture="blur" v-model="selectedValue" clearable :disabled="disabled" @change="handleChange">
        <el-option v-for="item in options" :key="item.Value" :label="item.Text" :value="item.Value">
            {{item.Text}}
        </el-option>
    </el-select>
</template>

<script type="text/javascript">
export default {
    name: "RtPicklist",
    props: {
        value: [String, Number],
        entity: {
            type: String,
            required: true
        },
        attribute: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        placeholder: {
            type: String,
            default: '请选择'
        }
    },
    data() {
        return {
            selectedValue: null,
            options: [],
        }
    },
    watch: {
        value(newVal, oldVal) {
            this.selectedValue = newVal;
        }
    },
    methods: {
        bindPicklist: function () {
            var self = this;
            rt.get("../api/crmpicklist/options/" + this.entity + "/" + this.attribute)
                .then(function (res) {
                    self.options = res;

                    // 发射 options-loaded 事件，允许父组件自定义处理选项
                    self.$emit("options-loaded", self.options);

                    if(self.value){
                        self.selectedValue = self.value;
                    }
                });
        },
        handleChange(val) {
            this.$emit("input", val);

            this.$emit("change",val);
        },
        blur(){
            setTimeout(()=>{
                this.$refs.selectDom.blur();
            },300)
        }
    },
    mounted: function () {
        this.bindPicklist();
    }
}
</script>


// WEBPACK FOOTER //
// main.vue?2500c40f